export type FileSnapshot = {
    id: string;
    documentType: DocumentType;
    documentKind: StatementType | null;
    name: string;
    sourceType: string;
    producedFromFile: string;
    companyId: string;
    createdBy: string | null;
    createdAt: string;
    meta: {
        rawConnector: {
            kind: ConnectorType;
            id: string;
        } | null;
        rawSource: string | null;
        extractionResultId: string | null;
    };
};

export enum DocumentType {
    CLEANED = "cleaned",
    LABELED = "labeled",
}

export enum StatementType {
    INCOME_STATEMENT = "income_statement",
    BALANCE_SHEET = "balance_sheet",
    MIXED = "mixed",
}

export enum ConnectorType {
    QUICKBOOKS = "quickbooks",
    QUICKBOOKS_DESKTOP = "quickbooks_desktop",
    QUICKBOOKS_SANDBOX = "quickbooks_sandbox",
    NETSUITE = "netsuite",
    PLAID = "plaid",
    STRIPE = "stripe",
    STRIPE_TEST = "stripe_test",
    SQUARE = "square",
    SQUARE_TEST = "square_test",
    WAVE = "wave",
    SHOPIFY = "shopify",
    SAGE_50 = "sage_50",
    SAGE_INTACCT = "sage_intacct",
    XERO = "xero",
}

export enum SourceType {
    Connector = "connector",
    UploadedFile = "uploaded_file",
}
